import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import Compare from "./page/Compare/Compare";
import Product from "./page/Product/Product";
import Calculator from "./page/Calculator/Calculator";
import ResultTCO from "./page/Result/ResultTCO";
import Result3YC from "./page/Result/Result3YC";
import History from "./page/History/History";
import ViewTCO from "./page/View/ViewTCO";
import View3YC from "./page/View/View3YC";
import Error from "./page/Error/Error";
import Term from "./page/Term/Term";
import Ebook from "./page/EBook/EBook";
import Activate from './page/Activate/Activate'
import Resetpassword from "./page/Resetpassword/Resetpassword";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@grapecity/wijmo.styles/wijmo.css';

// // Protected Route
const SecuredRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={
      (props) => (
        <Component {...props} />
      )
    }
  />
);

class App extends Component {
  redirectToError = () => {
    return <Redirect to="/Error" />;
  };
  redirectToCalculator = () => {
    return <Redirect to="/Calculator" />;
  };

  render() {
    return (
      <Router>
        <Switch>
          <Route path="/Activate" component={Activate} />
          <Route path="/Compare" component={Compare} />
          <Route path="/Product" component={Product} />
          <Route path="/Calculator" component={Calculator} />
          <Route path="/ResultTCO" component={ResultTCO} />
          <Route path="/Result3YC" component={Result3YC} />
          <Route path="/History" component={History} />
          <Route path="/ViewTCO" component={ViewTCO} />
          <Route path="/View3YC" component={View3YC} />
          <Route path="/term" component={Term} />
          <Route path="/resetpassword" component={Resetpassword} />

          {/* <SecuredRoute path="/Error" component={Error} /> */}

          <Route exact={true} path="/" component={this.redirectToCalculator} />
          {/* <Route exact={true} path="*" component={this.redirectToError} /> */}

        </Switch>
      </Router>
    );
  }
}

export default App;
